import { Routes } from '@angular/router';
import {
    ChangePasswordComponent,
    LoginComponent,
} from './core/auth';

export const routes: Routes = [
	{
		path: '',
		pathMatch: 'full',
		redirectTo: 'home-screen',
	},
    {
        path: 'login',
        component: LoginComponent,
    },
    {
        path: 'recover-password',
        component: ChangePasswordComponent,
    },
	{
		path: '',
		loadChildren: () =>
			import('./features/features.module').then((module) => module.FeaturesModule),
	},
	{
		path: '**',
		redirectTo: 'login',
	},
];
